import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map, of, throwError } from 'rxjs';
import { FamilyStudent } from '../models/family-student.model';
import { Family } from '../models/family-response.model';
import { plainToInstance } from 'class-transformer';
import { FamilyRequest } from '../models/family-request.model';
import { FamilyFilter } from '../models/family-filter.model';
import { UpdateFamilyData } from '../models/family-data.model';
import { FamilyValidateDupDNIAccount } from '../models/family-response-validateduplicated-dniaccount.model';
import { DuplicatedDNIAccountBank } from '../models/family-request-dniaccountbank.model';

@Injectable({
  providedIn: 'root'
})
export class FamilyService {

  private apiUrl = `${environment.sgcApi}`;
  private familyRoute = 'family';

  constructor(
    private httpClient: HttpClient
  ) {}

  getFamilyStudentById(familyId: number, exerciseId: number) : Observable<FamilyStudent> {
    let endpoint = `${this.apiUrl}${this.familyRoute}/familyId/${familyId}/exerciseId/${exerciseId}/students`;
    return this.httpClient.get<FamilyStudent>(endpoint)
      .pipe(map((data) => data));
  }

  getFamiliesByFilter(user: string, familyFilter: FamilyFilter) {
    let endpoint = `${this.apiUrl}${this.familyRoute}/${user}/user${this.getFilters(familyFilter)}`;
    return this.httpClient.get<Family[]>(endpoint)
      .pipe(map((families) => {
        return plainToInstance(Family, families as Family[]);
      }));
  }

  createFamily(family: FamilyRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.familyRoute}/${user}/user`;
    return  this.httpClient.post<number>(endpoint, family).pipe(
      map(data => data)
    );
  }

  updateFamily(updateFamilyData: UpdateFamilyData, user: string) {
    let endpoint = `${this.apiUrl}${this.familyRoute}/${user}/user`;
    return this.httpClient.put(endpoint, JSON.stringify(updateFamilyData));
  }

  deleteFamily(familyId: number, user: string) {
    let endpoint = `${this.apiUrl}${this.familyRoute}/${user}/user/${familyId}/familyId/delete`;
    return this.httpClient.delete(endpoint);
  }

  getIsDuplicatedDNIBank(duplicatedDNIBankAccount : DuplicatedDNIAccountBank) {
    let endpoint = `${this.apiUrl}${this.familyRoute}/IsDuplicatedDNIAccountBank`;
    return this.httpClient.post<FamilyValidateDupDNIAccount>(endpoint, JSON.stringify(duplicatedDNIBankAccount)).pipe(
      map(data => data)
    );
  }

  private getFilters(familyFilter: FamilyFilter) {
    let urlFilter = '/?filters=';
    urlFilter += familyFilter.exerciseId ? 'exerciseId=' + familyFilter.exerciseId.toString() + ';' : '';
    urlFilter += familyFilter.zoneId ? 'zoneId=' + familyFilter.zoneId.toString() + ';' : '';
    urlFilter += familyFilter.profitCenterCode != '' ? 'centerCode=' + familyFilter.profitCenterCode + ';' : '';
    urlFilter += familyFilter.schoolId ? 'schoolId=' + familyFilter.schoolId.toString() + ';' : '';
    urlFilter += familyFilter.identification ? 'identification=' + familyFilter.identification + ';'  : '';
    urlFilter += familyFilter.customerNumber ? 'customerNumber=' + familyFilter.customerNumber + ';'  : '';
    urlFilter += familyFilter.isActive ? 'isActive=' + familyFilter.isActive + ';'  : '';
    return urlFilter;
  }
}
